export default class ExtensionInfoItemModel {
  extensionInfoItemId: string = ''
  extensionInfoId: string = ''
  details: string = ''
  order: number = 0
  isChecked: boolean = false
  answerNotes: string = ''
  noteId: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
